module.exports = __webpack_public_path__ + "static/media/35522837_1946626955361232_1214952677880889344_o.e0e218d1.jpg";